import flow from 'lodash/flow';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import Content from './view.tsx';

export default flow(
	withFireUiAnalytics({
		onEnabledChange: 'pages',
	}),
	injectIntl,
)(Content);
